import { relations, sql } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../../auth'
import { BookFormat, BookLevel, BookTheme } from '../../content'

export const BookSearch = pgTable(
  'book_search',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'cascade' }),
    searchTerm: text(),
    age: integer().array(),
    bookThemeId: uuid().references(() => BookTheme.id, { onDelete: 'set null' }),
    bookLevelId: uuid().references(() => BookLevel.id, { onDelete: 'set null' }),
    bookFormatId: uuid().references(() => BookFormat.id, { onDelete: 'set null' }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [index('idx_book_search_user').on(t.userId)],
)

export const bookSearchRelations = relations(BookSearch, ({ one }) => ({
  user: one(user, {
    fields: [BookSearch.userId],
    references: [user.id],
  }),

  bookTheme: one(BookTheme, {
    fields: [BookSearch.bookThemeId],
    references: [BookTheme.id],
  }),

  bookLevel: one(BookLevel, {
    fields: [BookSearch.bookLevelId],
    references: [BookLevel.id],
  }),

  bookFormat: one(BookFormat, {
    fields: [BookSearch.bookFormatId],
    references: [BookFormat.id],
  }),
}))

export const InsertBookSearchSchema = createInsertSchema(BookSearch).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectBookSearchSchema = createSelectSchema(BookSearch)

export type InsertBookSearch = typeof BookSearch.$inferInsert
export type SelectBookSearch = typeof BookSearch.$inferSelect
